export const extractCssVariables = (
  flattenedCssVariables: Record<string, string>,
  variablesToExtract: string[],
): Record<string, string> => {
  if (!flattenedCssVariables || typeof flattenedCssVariables !== "object") {
    console.warn(
      "Invalid flattenedCssVariables provided to extractCssVariables",
    );
    return {};
  }

  if (!Array.isArray(variablesToExtract) || variablesToExtract.length === 0) {
    console.warn("No variables to extract provided to extractCssVariables");
    return {};
  }

  const result: Record<string, string> = {};

  variablesToExtract.forEach(variable => {
    if (variable in flattenedCssVariables) {
      const variableName = `var(--${variable})`;
      result[variableName] = flattenedCssVariables[variable];
    }
  });

  return result;
};
